const NAME = "ISSUE_VACATIONS";

export default NAME;
